import type { SVGProps } from "react";
export interface TrafficSignalIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TrafficSignalIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TrafficSignalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7 3.375c.62 0 1.125.504 1.125 1.125v15c0 .621-.504 1.125-1.125 1.125h-.5A5.625 5.625 0 0 1 .875 15c0-.741.496-1.366 1.175-1.562A5.6 5.6 0 0 1 .875 10c0-.74.496-1.366 1.175-1.561a5.6 5.6 0 0 1-1.175-3.44c0-.897.727-1.624 1.625-1.624zm-3.815 12.25a3.37 3.37 0 0 0 2.69 2.689v-2.688zm14.94 2.689a3.37 3.37 0 0 0 2.69-2.688h-2.69zm-6.626-1.685a.62.62 0 0 0-.124.37l.013.127a.6.6 0 0 0 .111.244zm1.001.741a.6.6 0 0 0 .113-.245l.011-.125-.011-.127a.6.6 0 0 0-.113-.244zm-9.315-6.746a3.37 3.37 0 0 0 2.69 2.69v-2.69zm14.94 2.69a3.37 3.37 0 0 0 2.69-2.69h-2.69zm-6.626-1.686a.62.62 0 0 0-.124.372l.013.126a.6.6 0 0 0 .111.245zm1.001.743a.6.6 0 0 0 .113-.245l.011-.126-.011-.126a.6.6 0 0 0-.113-.246zM3.185 5.625a3.37 3.37 0 0 0 2.69 2.69v-2.69zm14.94 2.69a3.375 3.375 0 0 0 2.69-2.69h-2.69zm-6.626-1.687a.62.62 0 0 0-.124.372l.013.126c.019.09.059.172.111.244zm1.001.742a.6.6 0 0 0 .113-.244L12.624 7l-.011-.125a.6.6 0 0 0-.113-.247zM13.625 17a1.626 1.626 0 0 1-3.242.166L10.375 17l.008-.166a1.626 1.626 0 0 1 1.618-1.459l.165.009c.82.083 1.459.774 1.459 1.616m0-5a1.625 1.625 0 0 1-3.242.165L10.375 12l.008-.165a1.625 1.625 0 0 1 1.618-1.46l.165.008c.82.083 1.459.776 1.459 1.617m0-5a1.625 1.625 0 0 1-3.242.166L10.375 7l.008-.167a1.626 1.626 0 0 1 1.618-1.458l.165.008c.82.083 1.459.776 1.459 1.617m9.5-2c0 1.295-.44 2.488-1.177 3.439.68.195 1.177.82 1.177 1.562 0 1.295-.44 2.487-1.177 3.438.68.194 1.177.82 1.177 1.561a5.625 5.625 0 0 1-5.625 5.625H17a1.125 1.125 0 0 1-1.125-1.125v-15l.006-.116A1.125 1.125 0 0 1 17 3.375h4.5c.897 0 1.624.727 1.625 1.625"
      />
      <path
        fill={color}
        d="M15.875 4.5a.876.876 0 0 0-.876-.875H9a.876.876 0 0 0-.874.875v15c0 .483.391.875.875.875h6a.876.876 0 0 0 .875-.875zm2.25 15c0 1.725-1.4 3.125-3.126 3.125H9A3.126 3.126 0 0 1 5.876 19.5v-15A3.125 3.125 0 0 1 9 1.375h6A3.126 3.126 0 0 1 18.124 4.5v15Z"
      />
    </svg>
  );
}
